import React, { useEffect, useState } from "react";
import { Modal, Rate, Button, Tabs } from "antd";
import Main from "../../components/layout/Main";
import { Check, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useSubscription } from "../../context/SubscriptionContext";
import { Severty, ShowToast } from "../../helper/toast";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../../context/WalletContext";
import { chargePayment } from "../../helper/functions";
import { useLocation } from "react-router-dom";

const SubscriptionsIndex = () => {
  const [selectedPlan, setSelectedPlan] = useState({});
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const location = useLocation();
  const [subscriptions, setSubscriptions] = useState([]);
  const [myPlan, setMyPlan] = useState({});
  const userProfileData = JSON.parse(localStorage.getItem("userProfile"));
  const { getSubscriptions, getMyPlan, purchasePlan, cancelSubscription } =
    useSubscription();
  const [benefits, setBenifits] = useState({});

  // ----------- Handlers -------------
  const fetchSubscriptions = async () => {
    try {
      const response = await getSubscriptions();
      setSubscriptions(response.data.data.data);
      // Set default first plan
      if (response.data.data.data.length > 0) {
        setSelectedPlan(response.data.data.data[0]);
        setBenifits(response.data.data.data[0].benefits);
      }
      const result = await getMyPlan();
      setMyPlan(result.data.data.subscription);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };

  // ------------- Purchase Plan ------------
  // const purchasePlanHandler = async (planId) => {
  //   try {
  //     if (myPlan && myPlan.isExpired === false) {
  //       ShowToast("You already have a subscription plan", Severty.ERROR);
  //       return;
  //     }
  //     // ----------- Here called api to U Payments -----------
  //     const data = {
  //       planId: planId,
  //       gatewayResponse: {
  //         "G-payid": "6837493437@ybl",
  //       },
  //       notes: "Buy subscription plan of Monthly",
  //     };

  //     const response = await purchasePlan(data);
  //     if (response.status === 200) {
  //       ShowToast(response.data.message, Severty.SUCCESS);
  //       fetchSubscriptions();
  //     }
  //   } catch (error) {
  //     console.log("Error occurred when purchase plan", error);
  //   }
  // };

  const purchasePlanHandler = async (packageData) => {
    try {
      if (myPlan && myPlan.isExpired === false) {
        ShowToast("You already have a subscription plan", Severty.ERROR);
        return;
      }

      const baseUrl = window.location.origin;
      // save bundle  data in localstorage
      localStorage.setItem(
        "subsCriptionData",
        JSON.stringify({
          amount: packageData?.price,
          planId: packageData?._id,
          notes: `Top-up via `,
        }),
      );
      // ----------- Here called api to U Payments -----------
      const data = {
        order: {
          id: packageData?._id,
          description: `Payment for Order ${"ORD" + packageData?._id}`,
          currency: "KWD",
          amount: packageData?.price,
        },
        paymentGateway: {
          src: "",
        },
        language: "en",
        tokens: {
          customerUniqueToken: Number(userProfileData?.customerUniqueToken),
        },
        reference: {
          id: Date.now().toString(),
        },
        customer: {
          uniqueId: userProfileData?._id,
          name: userProfileData?.name,
          email: userProfileData?.email,
          mobile: userProfileData?.phone,
        },
        returnUrl: `${baseUrl}/subscriptions`,
        cancelUrl: `${baseUrl}/subscriptions`,
        notificationUrl: `${baseUrl}/subscriptions`,
      };
      const response = await chargePayment(data);
      const link = response.data.link;
      window.location.href = link;
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  // --------- call the post api if payment is successfull -------------
  const handlePayIn = async (paymentResult) => {
    const storedData = JSON.parse(localStorage.getItem("subsCriptionData"));
    const data = {
      planId: storedData.planId,
      amount: storedData.amount,
      notes: storedData.notes,
      status: "Completed",
      gatewayResponse: paymentResult,
    };
    const response = await purchasePlan(data);

    console.log("response subscription-->", response);
    if (response.status === 200) {
      navigate("/subscriptions");
    }
  };

  // ------------- Cancel Subscription ------------
  const cancelSubscriptionHandler = async () => {
    try {
      const response = await cancelSubscription();
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
        fetchSubscriptions();
      }
    } catch (error) {
      console.log("Error occurred when cancel subscription", error);
    }
  };

  // ------ Readable Formate Keys -----
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, " $1") // insert space before capital letter
      .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
  };

  const formatValue = (value) => {
    if (typeof value === "boolean") {
      return value ? "Enabled" : "Disabled";
    }
    if (value === null) {
      return "N/A";
    }

    return value;
  };

  // ------------- Use Stats ------------
  useEffect(() => {
    fetchSubscriptions();
  }, []);

  useEffect(() => {
    setActiveTab(Object.keys(myPlan || {}).length === 0 ? "1" : "2");
  }, [myPlan]);

  // when payment is confirmed
  useEffect(() => {
    if (!location.search) return;
    const paymentResult = Object.fromEntries(
      new URLSearchParams(location.search),
    );
    if (
      paymentResult.result === "CAPTURED" ||
      paymentResult.result === "NOT CAPTURED"
    ) {
      ShowToast("Payment Successful", Severty.SUCCESS);
      handlePayIn(paymentResult);
    } else {
      ShowToast("Payment Failed", Severty.ERROR);
    }
  }, [location.search]);

  console.log("selectedPlan===>", selectedPlan);

  return (
    <>
      <Main>
        <div className="notification-section section-main">
          <div className="notifications-headding">
            <div className="orange-header">Subscriptions</div>
            <p>To place a bid, you need to pay the one-time</p>
            <p>auction insurance fee.</p>
          </div>
          <div className="subscription-tabs">
            <Tabs
              activeKey={activeTab}
              className="custom-tabs"
              onChange={(key) => setActiveTab(key)}
              items={[
                {
                  key: "1",
                  label: <span className="tab-one">Subscription Plans</span>,
                  children: (
                    <div className="premium-plan-container">
                      {/* Left Features */}
                      <div className="features-section">
                        <h3>{selectedPlan?.name?.en || "Premium Plan"}</h3>
                        <ul>
                          {Object.keys(benefits).map((key) => (
                            <li key={key}>
                              <Check />
                              {/* {key}: {benefits[key]} */}
                              {formatKey(key)} : {formatValue(benefits[key])}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Right Pricing */}
                      <div className="pricing-section">
                        <div className="subscribe-plan-card">
                          {subscriptions.map((plan, index) => {
                            return (
                              <div
                                key={index}
                                className={`price-card ${
                                  selectedPlan?._id === plan._id ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedPlan(plan);
                                  setBenifits(plan.benefits);
                                }}
                              >
                                <p>{plan.name.en}</p>
                                <span className="plan-label">
                                  {plan.duration}
                                </span>
                                <h2>KWD{plan.price}</h2>
                                <p>Billed {plan.duration}</p>
                              </div>
                            );
                          })}
                        </div>

                        <Button
                          type="default"
                          className="Fill-button mx-width-100"
                          onClick={() => purchasePlanHandler(selectedPlan)}
                        >
                          Subscribe
                        </Button>
                        <p className="price-note">
                          Prices shown in KWD. Subscription auto-renews monthly.
                        </p>
                      </div>
                    </div>
                  ),
                },
                {
                  key: "2",
                  label: (
                    <span className="tab-one">Manage Your Subscription</span>
                  ),
                  children: (
                    <>
                      <div className="manage-subscription-card">
                        <div className="manage-subscription-card-header">
                          <h6>
                            {myPlan && myPlan?.planSnapshot?.name?.en
                              ? myPlan?.planSnapshot?.name?.en
                              : "No Plan Activated"}
                          </h6>
                        </div>
                        {myPlan && myPlan?.planSnapshot && (
                          <div className="manage-subscription-card-body">
                            <div className="features-section">
                              <ul>
                                {Object.keys(
                                  myPlan?.planSnapshot?.benefits ?? {},
                                ).map((key) => (
                                  <li key={key}>
                                    <Check />
                                    {formatKey(key)} :{" "}
                                    {formatValue(
                                      myPlan?.planSnapshot?.benefits[key],
                                    )}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className="payment-date-update">
                              <h5>Payment</h5>
                              <p>
                                Your next bill is for{" "}
                                {myPlan?.planSnapshot?.price} KWD on{" "}
                                {moment(myPlan.endDate).format("DD MMM YYYY")}
                              </p>
                              {/* <div className="payment-updating">
                                <h6>Upayment ending in 0000</h6>
                                <Link>Update</Link>
                              </div> */}
                            </div>
                          </div>
                        )}
                      </div>
                      {myPlan && Object.keys(myPlan).length > 0 && (
                        <div className="premiumplan-footer">
                          {/* <Button className="border-button">Change Plan</Button> */}
                          <Button
                            className="border-button"
                            onClick={cancelSubscriptionHandler}
                          >
                            Cancel Subscription
                          </Button>
                        </div>
                      )}
                    </>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </Main>
    </>
  );
};

export default SubscriptionsIndex;
